/*
 * <variant-ingredients> — swaps an accordion's content per selected variant.
 *
 * Counterpart of the JSON map emitted by snippets/variant-picker.liquid
 * (script[data-variant-metafields="custom.variant_ingredients"]): it listens for
 * the theme's `variant:change` event and replaces the wrapped accordion's
 * `.accordion__content` with the selected variant's ingredient text. A variant
 * without the metafield falls back to the server-rendered (static) content, so
 * products whose metafields are not filled in behave exactly as before.
 *
 * The map is read lazily on every change (not cached): the variant picker is in
 * the theme's partial-rerender whitelist, so its <script> node is replaced with
 * fresh markup on each variant change.
 */
(function () {
  if (window.customElements.get('variant-ingredients')) {
    return;
  }

  function getCurrentVariant() {
    var node =
      document.querySelector('variant-picker[context="main_product"] script[data-variant]') ||
      document.querySelector('variant-picker script[data-variant]');

    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getIngredientsMap() {
    var node = document.querySelector(
      'variant-picker[context="main_product"] script[data-variant-metafields="custom.variant_ingredients"]'
    );

    if (!node) {
      return null;
    }

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  var VariantIngredients = class extends HTMLElement {
    connectedCallback() {
      var content = this.querySelector('.accordion__content');

      // Fallback for variants whose metafield is empty = the block's STATIC content.
      // Kremi (09-18): when the initial variant HAS text, the server already replaced the
      // static content with it, so capturing innerHTML here stored the INITIAL VARIANT's
      // text — switching to a text-less variant (e.g. the mask TRIO) then kept showing
      // e.g. Vitamin C's list. The server now emits the static content in
      // <template data-variant-ingredients-fallback> in exactly that case; otherwise the
      // initial render IS the static content and capturing it is correct.
      var fallbackTemplate = this.querySelector('template[data-variant-ingredients-fallback]');
      this._fallbackHTML = fallbackTemplate
        ? fallbackTemplate.innerHTML
        : (content ? content.innerHTML : '');

      this._onVariantChange = function (event) {
        this.apply(event.detail && event.detail.variant);
      }.bind(this);

      document.addEventListener('variant:change', this._onVariantChange);

      // Initial sync (deep links with ?variant= are already server-rendered
      // correctly; this is a no-op safety for bfcache restores).
      this.apply(getCurrentVariant());
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    apply(variant) {
      var content = this.querySelector('.accordion__content');

      if (!content || !variant || !variant.id) {
        return;
      }

      var map = getIngredientsMap();
      var text = map ? map[String(variant.id)] : null;

      if (typeof text !== 'string' || text.trim() === '') {
        if (content.innerHTML !== this._fallbackHTML) {
          content.innerHTML = this._fallbackHTML;
          // The static content may be the set-ingredients slider: its height-fit script
          // only scans tracks present at load, so tell it a new track appeared.
          document.dispatchEvent(new CustomEvent('kremi:ingredients:rendered'));
        }
        return;
      }

      // Build via DOM APIs (no innerHTML with raw text) so the plain-text
      // metafield can never inject markup; newlines become <br>.
      var paragraph = document.createElement('p');
      var lines = text.split(/\r?\n/);

      for (var i = 0; i < lines.length; i++) {
        if (i > 0) {
          paragraph.appendChild(document.createElement('br'));
        }
        paragraph.appendChild(document.createTextNode(lines[i]));
      }

      content.replaceChildren(paragraph);
    }
  };

  window.customElements.define('variant-ingredients', VariantIngredients);
})();
